import { useCallback, useContext } from "react";
import { HotelContext } from "../context/hotel";
import { CheckInContext } from "../context/checkin";
// import { get as apiBffGet, post as apiBffPost, put as apiBffPut, patch as apiBffPatch } from "../services/api-bff";
import useApiBff from "./useApiBff";

const useApi = () => {
    const maxAttempts = 3;
    const { data: hotel } = useContext(HotelContext);
    const { data: checkIn } = useContext(CheckInContext);
    const { get: apiBffGet, post: apiBffPost, put: apiBffPut, patch: apiBffPatch } = useApiBff();

    const get = async (path, attempt = 1) => {
        let r = null;
        if (attempt > maxAttempts) return null;
        try {
            r = await apiBffGet(path)
        } catch (error) {
            let _refreshed = false;
            if (error.message === "Hotel Token") {
                _refreshed = await _refreshToken("hotel", path);
            }
            if (error.message === "CheckIn Token") {
                _refreshed = await _refreshToken("checkIn", path);
            }
            if (_refreshed) {
                return await get(path, attempt + 1);
            }
            throw error;
        }
        return r;
    };

    const post = async (path, body, attempt = 1) => {
        let r = null;
        if (attempt > maxAttempts) return null;
        try {
            r = await apiBffPost(path, body);
        } catch (error) {
            let _refreshed = false;
            if (error.message === "Hotel Token") {
                _refreshed = await _refreshToken("hotel", path);
            }
            if (error.message === "CheckIn Token") {
                _refreshed = await _refreshToken("checkIn", path);
            }
            if (_refreshed) {
                r = await post(path, body, attempt + 1);
            }
        }
        return r;
    }

    const put = async (path, body, attempt = 1) => {
        let r = null;
        if (attempt > maxAttempts) return null;
        try {
            r = await apiBffPut(path, body);
        } catch (error) {
            let _refreshed = false;
            if (error.message === "Hotel Token") {
                _refreshed = await _refreshToken("hotel", path);
            }
            if (error.message === "CheckIn Token") {
                _refreshed = await _refreshToken("checkIn", path);
            }
            if (_refreshed) {
                r = await put(path, body, attempt + 1);
            }
        }
        return r;
    }

    const patch = async (path, body, attempt = 1) => {
        let r = null;
        if (attempt > maxAttempts) return null;
        try {
            r = await apiBffPatch(path, body);
        } catch (error) {
            let _refreshed = false;
            if (error.message === "Hotel Token") {
                _refreshed = await _refreshToken("hotel", path);
            }
            if (error.message === "CheckIn Token") {
                _refreshed = await _refreshToken("checkIn", path);
            }
            if (_refreshed) {
                r = await patch(path, body, attempt + 1);
            }
        }
        return r;
    }

    const _refreshToken = async (entity, path) => {
        const _hotelId = hotel?.id || null;

        if (entity === "hotel" && _hotelId) {
            const resp_token = await apiBffGet(`hotels/?id=${_hotelId}`);
            if (resp_token.id === _hotelId) {
                return true;
            }
        }

        if (entity === "checkIn" && _hotelId) {
            let _checkInId = checkIn?.id || null;

            // TODO:: Parche
            if (!_checkInId) {
                const path_arr = path.split('/');
                if (path_arr.length >= 4 && path_arr[2] === "checkins") {
                    _checkInId = path_arr[3]
                }
            }
            // ----

            if (_hotelId && _checkInId) {
                const resp_token = await apiBffGet(`hotels/${_hotelId}/checkins/${_checkInId}/token`);
                if (resp_token.id === _checkInId) {
                    return true;
                }
            }

        }

        return false;
    }

    return {
        get,
        post,
        put,
        patch
    }

}

export default useApi;